// extracted by mini-css-extract-plugin
export var standaloneTable = "_fy-0";
export var standaloneTableWithBodyFill = "_fy-1";
export var withExtraHeader = "_fy-2";